"use client";

import Heading from "@/components/heading/heading";
import Tag from "@/components/tag/Tag";

import Picture1 from "@/public/png/itinerary/srilanka/ramboda-falls.jpg";
import Picture2 from "@/public/png/itinerary/srilanka/pinnawala-elephant.jpg";
import Picture3 from "@/public/png/itinerary/srilanka/temple-of-the-tooth.jpg";
import Picture4 from "@/public/png/itinerary/srilanka/gregory-lake.jpg";
import Picture5 from "@/public/png/itinerary/srilanka/hakgala-botanical-garde.jpg";
import Picture6 from "@/public/png/itinerary/srilanka/madu-river-boat-ride.jpg";
import Picture7 from "@/public/png/itinerary/srilanka/colombo-museum.jpg";


import arrowLeftNormal from "@/public/svg/itinerary/arrow-left-normal.svg"
import arrowRightNormal from "@/public/svg/itinerary/arrow-right-normal.svg"
import arrowLeftHover from "@/public/svg/itinerary/arrow-left-hover.svg"
import arrowRightHover from "@/public/svg/itinerary/arrow-right-hover.svg"


import Image from "next/image";

import "swiper/css";
import { Navigation, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import "./activities.scss";
import { useState } from "react";

const Activities = () => {
    const Tags = [
        {
            name: " All park entry fees",
        },
        {
            name: "Hotel transfers",
        },
        {
            name: "Friendly and informative tour guide",
        },
        {
            name: "Free Wi-Fi",
        },
    ];

    const slidesData = [{
        heading: "Ramboda Falls",
        desc:"A magnificent waterfall set in the lush highlands of Sri Lanka, offering breathtaking views and a refreshing mist. Surrounded by tea estates and verdant landscapes, it creates a tranquil and picturesque escape.", 
        image: Picture1
    }, {
        heading: "Pinnawala Elephant Orphanage",
        desc:"A special sanctuary dedicated to caring for orphaned and rescued elephants in a protected environment. Observe these gentle giants as they feed and bathe, and learn about vital conservation efforts",
        image: Picture2
    }, {
        heading: "Temple of the Tooth",
        desc:"A UNESCO World Heritage Site in Kandy, revered for enshrining the Sacred Tooth Relic of the Buddha. Experience a serene spiritual atmosphere and intricate architecture that draws pilgrims from around the world.",
        image: Picture3
    }, {
        heading: "Gregory Lake",
        desc:"A scenic highland reservoir in Nuwara Eliya, perfect for leisurely boat rides and picnics. Surrounded by rolling hills and cool mountain air, it offers a peaceful escape from the city.",
        image: Picture4
    }, {
        heading: "Hakgala Botanical Garden",
        desc:"A sprawling garden in the highlands of Nuwara Eliya, home to vibrant blooms and lush foliage. Its cool climate and serene setting make it an ideal spot for nature lovers and leisurely strolls.",
        image: Picture5
    }, {
        heading: "Madu River Boat Ride",
        desc:"A scenic excursion through mangrove-rich waterways, offering glimpses of local wildlife and serene islets. Experience the region’s natural beauty up close while cruising along this tranquil river.",
        image: Picture6
    }, {
        heading: "Colombo Museum",
        desc:"One of Sri Lanka’s oldest museums, home to historical artifacts and cultural treasures. Explore diverse exhibits that trace the nation’s heritage from ancient times to the modern era.",
        image: Picture7
    }]

    const [currentSlideData, setCurrentSlideData] = useState(slidesData[0])
    const [imageSrcL, setImageSrcL] = useState(arrowLeftNormal);
    const [imageSrcR, setImageSrcR] = useState(arrowRightNormal);

    return (
        <div
            className="activities-block py-9 flex flex-col gap-6 relative z-[0]"
        >

            <span id="activities" className="anchor"></span>
            <Heading as="h2">Activities / Sightseeing</Heading>
            <div className="slider-details flex flex-col md:flex-row items-center gap-2">
                <div className="picture-wrapper flex flex-col gap-4">
                    <div className="picture">
                        <Swiper
                            modules={[Navigation, Pagination]}
                            slidesPerView={1}
                            spaceBetween={30}
                            centeredSlides={true}
                            onSlideChange={(e) => { setCurrentSlideData(slidesData[e.activeIndex]) }}
                            className=""
                            wrapperClass=""
                            navigation={{
                                nextEl: ".right-activities",
                                prevEl: ".left-activities",
                            }}
                            pagination={{
                                el: "#activities-pagination",
                                clickable: true,
                                bulletClass: "indicator-item",
                                bulletElement: "li",
                                bulletActiveClass: "active",
                            }}
                        >
                            {slidesData.map((item, index) => {
                                return (
                                    <SwiperSlide key={index}>
                                        <figure>
                                            <Image loading="lazy"
                                                src={item.image}
                                                alt="Picture1"

                                            />
                                        </figure>

                                    </SwiperSlide>

                                );
                            })}
                        </Swiper>
                        {/* <div className="arrow-width-controler"> */}
                        <div className="left-activities arrow-nagivation flex-center">
                            <Image loading="lazy"
                                src={imageSrcL}
                                onMouseEnter={() => setImageSrcL(arrowLeftHover)}
                                onMouseLeave={() => setImageSrcL(arrowLeftNormal)}
                                alt="arrow left"
                                className="arrow-icon"
                                width={40}
                                height={40}
                            />
                        </div>
                        <div className="right-activities arrow-nagivation flex-center">
                            <Image loading="lazy"
                                src={imageSrcR}
                                onMouseEnter={() => setImageSrcR(arrowRightHover)}
                                onMouseLeave={() => setImageSrcR(arrowRightNormal)}
                                alt="arrow right"
                                className="arrow-icon"
                                width={40}
                                height={40}
                            />
                        </div>
                        {/* </div> */}
                    </div>
                    <ul
                        className="indicator flex-center gap-1 swiper-pagination"
                        id="activities-pagination"
                    >
                        <li className="indicator-item active" />
                        <li className="indicator-item" />
                        <li className="indicator-item" />
                    </ul>
                </div>
                <div className="d-block">
                <Heading as="h3" className="md:ml-10">{currentSlideData.heading}</Heading>
                <p  className="md:ml-10 mt-3">{currentSlideData.desc}</p>
                </div>


                {/* <span className="lead">Full Day</span>
                <ul className="rating-list flex flex-wrap items-center gap-1">
                    <li className="rating-list-item">
                        <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                        >
                            <path
                                d="M13.7309 3.51001L15.4909 7.03001C15.7309 7.52001 16.3709 7.99001 16.9109 8.08001L20.1009 8.61001C22.1409 8.95001 22.6209 10.43 21.1509 11.89L18.6709 14.37C18.2509 14.79 18.0209 15.6 18.1509 16.18L18.8609 19.25C19.4209 21.68 18.1309 22.62 15.9809 21.35L12.9909 19.58C12.4509 19.26 11.5609 19.26 11.0109 19.58L8.02089 21.35C5.88089 22.62 4.58089 21.67 5.14089 19.25L5.85089 16.18C5.98089 15.6 5.75089 14.79 5.33089 14.37L2.85089 11.89C1.39089 10.43 1.86089 8.95001 3.90089 8.61001L7.09089 8.08001C7.62089 7.99001 8.26089 7.52001 8.50089 7.03001L10.2609 3.51001C11.2209 1.60001 12.7809 1.60001 13.7309 3.51001Z"
                                className="filled star"
                            />
                        </svg>
                    </li>
                    <li className="rating-list-item">
                        <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                        >
                            <path
                                d="M13.7309 3.51001L15.4909 7.03001C15.7309 7.52001 16.3709 7.99001 16.9109 8.08001L20.1009 8.61001C22.1409 8.95001 22.6209 10.43 21.1509 11.89L18.6709 14.37C18.2509 14.79 18.0209 15.6 18.1509 16.18L18.8609 19.25C19.4209 21.68 18.1309 22.62 15.9809 21.35L12.9909 19.58C12.4509 19.26 11.5609 19.26 11.0109 19.58L8.02089 21.35C5.88089 22.62 4.58089 21.67 5.14089 19.25L5.85089 16.18C5.98089 15.6 5.75089 14.79 5.33089 14.37L2.85089 11.89C1.39089 10.43 1.86089 8.95001 3.90089 8.61001L7.09089 8.08001C7.62089 7.99001 8.26089 7.52001 8.50089 7.03001L10.2609 3.51001C11.2209 1.60001 12.7809 1.60001 13.7309 3.51001Z"
                                className="filled star"
                            />
                        </svg>
                    </li>
                    <li className="rating-list-item">
                        <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                        >
                            <path
                                d="M13.7309 3.51001L15.4909 7.03001C15.7309 7.52001 16.3709 7.99001 16.9109 8.08001L20.1009 8.61001C22.1409 8.95001 22.6209 10.43 21.1509 11.89L18.6709 14.37C18.2509 14.79 18.0209 15.6 18.1509 16.18L18.8609 19.25C19.4209 21.68 18.1309 22.62 15.9809 21.35L12.9909 19.58C12.4509 19.26 11.5609 19.26 11.0109 19.58L8.02089 21.35C5.88089 22.62 4.58089 21.67 5.14089 19.25L5.85089 16.18C5.98089 15.6 5.75089 14.79 5.33089 14.37L2.85089 11.89C1.39089 10.43 1.86089 8.95001 3.90089 8.61001L7.09089 8.08001C7.62089 7.99001 8.26089 7.52001 8.50089 7.03001L10.2609 3.51001C11.2209 1.60001 12.7809 1.60001 13.7309 3.51001Z"
                                className="filled star"
                            />
                        </svg>
                    </li>
                    <li className="rating-list-item">
                        <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                        >
                            <path
                                d="M13.7309 3.51001L15.4909 7.03001C15.7309 7.52002 16.3709 7.99001 16.9109 8.08001L20.1009 8.61001C22.1409 8.95001 22.6209 10.43 21.1509 11.89L18.6709 14.37C18.2509 14.79 18.0209 15.6 18.1509 16.18L18.8609 19.25C19.4209 21.68 18.1309 22.62 15.9809 21.35L12.9909 19.58C12.4509 19.26 11.5609 19.26 11.0109 19.58L8.02089 21.35C5.88089 22.62 4.58089 21.67 5.14089 19.25L5.85089 16.18C5.98089 15.6 5.75089 14.79 5.33089 14.37L2.85089 11.89C1.39089 10.43 1.86089 8.95001 3.90089 8.61001L7.09089 8.08001C7.62089 7.99001 8.26089 7.52002 8.50089 7.03001L10.2609 3.51001C11.2209 1.60001 12.7809 1.60001 13.7309 3.51001Z"
                                className="unfilled star"
                            />
                        </svg>
                    </li>
                    <li className="rating-list-item">
                        <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                        >
                            <path
                                d="M13.7309 3.51001L15.4909 7.03001C15.7309 7.52002 16.3709 7.99001 16.9109 8.08001L20.1009 8.61001C22.1409 8.95001 22.6209 10.43 21.1509 11.89L18.6709 14.37C18.2509 14.79 18.0209 15.6 18.1509 16.18L18.8609 19.25C19.4209 21.68 18.1309 22.62 15.9809 21.35L12.9909 19.58C12.4509 19.26 11.5609 19.26 11.0109 19.58L8.02089 21.35C5.88089 22.62 4.58089 21.67 5.14089 19.25L5.85089 16.18C5.98089 15.6 5.75089 14.79 5.33089 14.37L2.85089 11.89C1.39089 10.43 1.86089 8.95001 3.90089 8.61001L7.09089 8.08001C7.62089 7.99001 8.26089 7.52002 8.50089 7.03001L10.2609 3.51001C11.2209 1.60001 12.7809 1.60001 13.7309 3.51001Z"
                                className="unfilled star"
                            />
                        </svg>
                    </li>
                </ul> */}
                {/* <ul className="tag-list flex flex-wrap items-center gap-3">
                    {Tags.map((t, index) => {
                        return <Tag title={t.name} key={index} />;
                    })}
                </ul> */}
            </div>
        </div>
    );
};

export default Activities;
